import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=855e76f4&scoped=true"
import script from "./Audio.vue?vue&type=script&lang=ts"
export * from "./Audio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855e76f4",
  null
  
)

export default component.exports